export interface Language {
  code: string;
  name: string;
  flag: string;
  native: string;
}

// All 55+ languages supported by Speechmatics Realtime API
export const SPEECHMATICS_LANGUAGES: Language[] = [
  // Major Languages
  { code: 'en', name: 'English', flag: '🇬🇧', native: 'English' },
  { code: 'es', name: 'Spanish', flag: '🇪🇸', native: 'Español' },
  { code: 'fr', name: 'French', flag: '🇫🇷', native: 'Français' },
  { code: 'de', name: 'German', flag: '🇩🇪', native: 'Deutsch' },
  { code: 'it', name: 'Italian', flag: '🇮🇹', native: 'Italiano' },
  { code: 'pt', name: 'Portuguese', flag: '🇵🇹', native: 'Português' },
  { code: 'nl', name: 'Dutch', flag: '🇳🇱', native: 'Nederlands' },
  { code: 'ru', name: 'Russian', flag: '🇷🇺', native: 'Русский' },
  { code: 'ja', name: 'Japanese', flag: '🇯🇵', native: '日本語' },
  { code: 'ko', name: 'Korean', flag: '🇰🇷', native: '한국어' },
  { code: 'zh', name: 'Mandarin', flag: '🇨🇳', native: '中文(普通话)' },
  { code: 'yue', name: 'Cantonese', flag: '🇭🇰', native: '廣東話' },
  { code: 'ar', name: 'Arabic', flag: '🇸🇦', native: 'العربية' },
  { code: 'hi', name: 'Hindi', flag: '🇮🇳', native: 'हिन्दी' },
  { code: 'bn', name: 'Bengali', flag: '🇧🇩', native: 'বাংলা' },
  
  // European Languages
  { code: 'pl', name: 'Polish', flag: '🇵🇱', native: 'Polski' },
  { code: 'cs', name: 'Czech', flag: '🇨🇿', native: 'Čeština' },
  { code: 'sk', name: 'Slovakian', flag: '🇸🇰', native: 'Slovenčina' },
  { code: 'sl', name: 'Slovenian', flag: '🇸🇮', native: 'Slovenščina' },
  { code: 'hr', name: 'Croatian', flag: '🇭🇷', native: 'Hrvatski' },
  { code: 'bg', name: 'Bulgarian', flag: '🇧🇬', native: 'Български' },
  { code: 'ro', name: 'Romanian', flag: '🇷🇴', native: 'Română' },
  { code: 'hu', name: 'Hungarian', flag: '🇭🇺', native: 'Magyar' },
  { code: 'el', name: 'Greek', flag: '🇬🇷', native: 'Ελληνικά' },
  { code: 'tr', name: 'Turkish', flag: '🇹🇷', native: 'Türkçe' },
  { code: 'uk', name: 'Ukrainian', flag: '🇺🇦', native: 'Українська' },
  { code: 'be', name: 'Belarusian', flag: '🇧🇾', native: 'Беларуская' },
  
  // Nordic Languages
  { code: 'sv', name: 'Swedish', flag: '🇸🇪', native: 'Svenska' },
  { code: 'no', name: 'Norwegian', flag: '🇳🇴', native: 'Norsk' },
  { code: 'da', name: 'Danish', flag: '🇩🇰', native: 'Dansk' },
  { code: 'fi', name: 'Finnish', flag: '🇫🇮', native: 'Suomi' },
  { code: 'et', name: 'Estonian', flag: '🇪🇪', native: 'Eesti' },
  { code: 'lv', name: 'Latvian', flag: '🇱🇻', native: 'Latviešu' },
  { code: 'lt', name: 'Lithuanian', flag: '🇱🇹', native: 'Lietuvių' },
  
  // Celtic & Regional European
  { code: 'ga', name: 'Irish', flag: '🇮🇪', native: 'Gaeilge' },
  { code: 'cy', name: 'Welsh', flag: '🏴', native: 'Cymraeg' },
  { code: 'eu', name: 'Basque', flag: '🏴', native: 'Euskara' },
  { code: 'ca', name: 'Catalan', flag: '🏴', native: 'Català' },
  { code: 'gl', name: 'Galician', flag: '🏴', native: 'Galego' },
  { code: 'mt', name: 'Maltese', flag: '🇲🇹', native: 'Malti' },
  
  // Middle Eastern & Central Asian
  { code: 'he', name: 'Hebrew', flag: '🇮🇱', native: 'עברית' },
  { code: 'fa', name: 'Persian', flag: '🇮🇷', native: 'فارسی' },
  { code: 'ur', name: 'Urdu', flag: '🇵🇰', native: 'اردو' },
  { code: 'ug', name: 'Uyghur', flag: '🏴', native: 'ئۇيغۇرچە' },
  { code: 'ba', name: 'Bashkir', flag: '🏴', native: 'Башҡортса' },
  { code: 'mn', name: 'Mongolian', flag: '🇲🇳', native: 'Монгол' },
  
  // South & Southeast Asian
  { code: 'mr', name: 'Marathi', flag: '🇮🇳', native: 'मराठी' },
  { code: 'ta', name: 'Tamil', flag: '🇮🇳', native: 'தமிழ்' },
  { code: 'th', name: 'Thai', flag: '🇹🇭', native: 'ไทย' },
  { code: 'vi', name: 'Vietnamese', flag: '🇻🇳', native: 'Tiếng Việt' },
  { code: 'id', name: 'Indonesian', flag: '🇮🇩', native: 'Bahasa Indonesia' },
  { code: 'ms', name: 'Malay', flag: '🇲🇾', native: 'Bahasa Melayu' },
  
  // African
  { code: 'sw', name: 'Swahili', flag: '🇹🇿', native: 'Kiswahili' },
  
  // Constructed Languages
  { code: 'eo', name: 'Esperanto', flag: '🏳️', native: 'Esperanto' },
  { code: 'ia', name: 'Interlingua', flag: '🏳️', native: 'Interlingua' }
];

// Helper function to get language by code
export const getLanguageByCode = (code: string): Language | undefined => {
  return SPEECHMATICS_LANGUAGES.find(lang => lang.code === code);
};

// Helper function for fuzzy search
export const searchLanguages = (query: string): Language[] => {
  if (!query.trim()) return SPEECHMATICS_LANGUAGES;
  
  const queryLower = query.toLowerCase();
  const words = queryLower.split(/\s+/);
  
  return SPEECHMATICS_LANGUAGES.filter((language) => {
    const searchableText = 
      `${language.name} ${language.native} ${language.code}`.toLowerCase();
    
    // Check if all words are found somewhere in the text
    return words.every((word) => searchableText.includes(word));
  });
};